import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import cx from 'classnames';
import colors from '~/constants/colors';
import theme from '~/constants/theme';
import companyTypeBackground from '~/img/companyTypeBackground.jpg';
import { useDirection } from '~/hooks/i18nHooks';

interface Props {
  header?: JSX.Element;
  className?: string;
}

const CompanyTypeContentLayout: FC<Props> = (props) => {
  const { className, header, children } = props;
  const dir = useDirection();

  return (
    <Container className={cx('CompanyTypeContentLayout', className)} dir={dir}>
      {header}
      <div className="CompanyTypeContentLayout-ContentAndImageContainer">
        <div className="CompanyTypeContentLayout-Content">{children}</div>
        <div className="CompanyTypeContentLayout-Image" />
      </div>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  .CompanyTypeContentLayout-ContentAndImageContainer {
    display: flex;
    flex: 1;
    .CompanyTypeContentLayout-Content {
      display: flex;
      flex: 1;
    }
    .CompanyTypeContentLayout-Image {
      display: none;
    }
  }
  @media (max-width: ${theme.breakpoints.md}px) {
    .CompanyTypeContentLayout-ContentAndImageContainer {
      .CompanyTypeContentLayout-Content {
        width: 40%;
      }
      .CompanyTypeContentLayout-Image {
        display: flex;
        flex: 1;
        margin-left: ${({ dir }) => (dir === 'ltr' ? 40 : 0)}px;
        margin-right: ${({ dir }) => (dir === 'rtl' ? 40 : 0)}px;
        min-height: 380px !important;
        max-height: 700px;
        border-radius: ${theme.containerBorderRadius}px;
        background-color: ${colors.componentBackground};
        background-size: cover;
        background-position: center;
        background-image: url(${companyTypeBackground});
        background-repeat: no-repeat;
        ${({ dir }) =>
          dir === 'rtl'
            ? css`
                transform: scaleX(-1);
              `
            : undefined}
      }
    }
  }
  @media (max-width: 650px) {
    .CompanyTypeContentLayout-ContentAndImageContainer {
      .CompanyTypeContentLayout-Content {
        width: 100%;
      }
      .CompanyTypeContentLayout-Image {
        display: none;
      }
    }
  }
`;

export default CompanyTypeContentLayout;
